import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

const Doctor = () => {
  const navigate = useNavigate();

  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    axios
      .get(`${process.env.REACT_APP_API_URL}/get-doctors`)
      .then((response) => {
        const data = response.data.doctors;
        if (Array.isArray(data)) {
          const sortedDoctors = data.sort((a, b) => b.id - a.id);

          setDoctors(sortedDoctors);
        } else {
          setDoctors([]);
          console.error("Expected an array but got:", data);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch doctors", error);
        setDoctors([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div id="doctor" className="mt-5 p-5" style={{ background: "aliceblue" }}>
      <Typography
        variant="h3"
        className="h3"
        sx={{ fontWeight: "bold", textAlign: "center", mb: 2, mt: 4 }}
        data-aos="fade-up"
      >
        Amazing Team Members
      </Typography>

      <Typography
        variant="h6"
        sx={{ textAlign: "center", mb: 3 }}
        data-aos="fade-up"
        data-aos-delay="200"
      >
        Providing top-notch medical care right at your doorstep.
        <br />
        Your health is our priority, anytime, anywhere.
      </Typography>

      {loading ? (
        <Typography sx={{ textAlign: "center", mt: 4 }}>Loading...</Typography>
      ) : doctors.length === 0 ? (
        <Typography sx={{ textAlign: "center", mt: 4 }}>
          No doctor profiles available.
        </Typography>
      ) : (
        <Grid container spacing={4} sx={{ paddingTop: 4 }}>
          {doctors.map((doctor, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={doctor.id}
              sx={{ display: "flex" }}
            >
              <Card
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  borderRadius: "15px",
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
                data-aos="fade-up"
                data-aos-delay={400 + index * 100}
                onClick={() => navigate(`/appointment/${doctor.id}`)}
              >
                <CardMedia
                  component="img"
                  image={`${process.env.REACT_APP_API_URL}/${doctor.profile_pic}`}
                  alt={doctor.name}
                  sx={{
                    height: 300,
                    width: "100%",
                    objectFit: "cover",
                    borderTopLeftRadius: "15px",
                    borderTopRightRadius: "15px",
                  }}
                />
                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    background: "white",
                    textAlign: "center",
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: "bold", mt: 1 }}>
                    {doctor.name}
                  </Typography>

                  <Divider
                    sx={{ backgroundColor: "black", height: "1px", marginY: 1 }}
                  />

                  <Typography variant="body2" sx={{ px: 1 }}>
                    {doctor.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default Doctor;
